import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin, Youtube, Mail, Phone, MapPin } from "lucide-react";

export default function Footer({ settings }) {
  const s = settings || {};
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[hsl(var(--primary))] text-white" data-testid="site-footer">
      <div className="container-x py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-2xl tracking-wide">Dr. Abhishek Garg</div>
          <p className="text-sm opacity-80 mt-3 leading-relaxed">
            Candidate for Executive Member, Delhi Medical Council. A united voice
            for ethical, modern, doctor-first reform.
          </p>
        </div>
        <div>
          <div className="label-eyebrow text-white/80 mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[hsl(var(--accent))]">About</Link></li>
            <li><Link to="/dmc-election" className="hover:text-[hsl(var(--accent))]">DMC Election</Link></li>
            <li><Link to="/vision" className="hover:text-[hsl(var(--accent))]">Vision</Link></li>
            <li><Link to="/research" className="hover:text-[hsl(var(--accent))]">Research</Link></li>
            <li><Link to="/connect" className="hover:text-[hsl(var(--accent))]">Connect</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-white/80 mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5" /> {s.phone || "+91 95558 85651"}</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5" /> {s.email || "contact.abhishekgarg@gmail.com"}</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5" /> {s.address || "New Delhi, India"}</li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-white/80 mb-4">Follow</div>
          <div className="flex gap-3">
            {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" aria-label="facebook" className="p-2 border border-white/20 hover:bg-[hsl(var(--accent))]"><Facebook size={16} /></a>}
            {s.twitter && <a href={s.twitter} target="_blank" rel="noreferrer" aria-label="twitter" className="p-2 border border-white/20 hover:bg-[hsl(var(--accent))]"><Twitter size={16} /></a>}
            {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="instagram" className="p-2 border border-white/20 hover:bg-[hsl(var(--accent))]"><Instagram size={16} /></a>}
            {s.linkedin && <a href={s.linkedin} target="_blank" rel="noreferrer" aria-label="linkedin" className="p-2 border border-white/20 hover:bg-[hsl(var(--accent))]"><Linkedin size={16} /></a>}
            {s.youtube && <a href={s.youtube} target="_blank" rel="noreferrer" aria-label="youtube" className="p-2 border border-white/20 hover:bg-[hsl(var(--accent))]"><Youtube size={16} /></a>}
            {!s.facebook && !s.twitter && !s.instagram && !s.linkedin && !s.youtube && (
              <span className="text-xs opacity-70">Social links coming soon.</span>
            )}
          </div>
          <Link
            to="/admin/login"
            className="block text-xs opacity-60 hover:opacity-100 mt-6 underline-offset-2 hover:underline"
            data-testid="admin-link"
          >
            Admin
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-4 text-xs flex flex-col sm:flex-row items-center justify-between gap-2 opacity-80">
          <span>© {year} Dr. Abhishek Garg Campaign · drabhishekgarg.in</span>
          <span>Authorised by Team Sankalp · Made with conviction.</span>
        </div>
      </div>
    </footer>
  );
}
